export const GET_SELLER_DOCUMENT_REQUEST = "GET_SELLER_DOCUMENT_REQUEST";
export const GET_SELLER_DOCUMENT_SUCCESS = "GET_SELLER_DOCUMENT_SUCCESS";
export const GET_SELLER_DOCUMENT_FAILURE = "GET_SELLER_DOCUMENT_FAILURE";

export const CREATE_SELLER_REQUEST = "CREATE_SELLER_REQUEST";
export const CREATE_SELLER_SUCCESS = "CREATE_SELLER_SUCCESS";
export const CREATE_SELLER_FAILURE = "CREATE_SELLER_FAILURE";

export const CREATE_FACTORY_OWNER_REQUEST = "CREATE_FACTORY_OWNER_REQUEST";
export const CREATE_FACTORY_OWNER_SUCCESS = "CREATE_FACTORY_OWNER_SUCCESS";
export const CREATE_FACTORY_OWNER_FAILURE = "CREATE_FACTORY_OWNER_FAILURE";

export const GET_FACTORY_OWNER_LIST_REQUEST = "GET_FACTORY_OWNER_LIST_REQUEST";
export const GET_FACTORY_OWNER_LIST_SUCCESS = "GET_FACTORY_OWNER_LIST_SUCCESS";
export const GET_FACTORY_OWNER_LIST_FAILURE = "GET_FACTORY_OWNER_LIST_FAILURE";

export const UPDATE_FACTORY_OWNER_REQUEST = "UPDATE_FACTORY_OWNER_REQUEST";
export const UPDATE_FACTORY_OWNER_SUCCESS = "UPDATE_FACTORY_OWNER_SUCCESS";
export const UPDATE_FACTORY_OWNER_FAILURE = "UPDATE_FACTORY_OWNER_FAILURE";

export const FETCH_FACTORY_OWNER_REQUEST = "FETCH_FACTORY_OWNER_REQUEST";
export const FETCH_FACTORY_OWNER_SUCCESS = "FETCH_FACTORY_OWNER_SUCCESS";
export const FETCH_FACTORY_OWNER_FAILURE = "FETCH_FACTORY_OWNER_FAILURE";

export const FETCH_FACTORY_REQUEST = "FETCH_FACTORY_REQUEST";
export const FETCH_FACTORY_SUCCESS = "FETCH_FACTORY_SUCCESS";
export const FETCH_FACTORY_FAILURE = "FETCH_FACTORY_FAILURE";

export const FETCH_FACTORY_BY_ID_REQUEST = "FETCH_FACTORY_BY_ID_REQUEST";
export const FETCH_FACTORY_BY_ID_SUCCESS = "FETCH_FACTORY_BY_ID_SUCCESS";
export const FETCH_FACTORY_BY_ID_FAILURE = "FETCH_FACTORY_BY_ID_FAILURE";

export const UPDATE_FACTORY_REQUEST = "UPDATE_FACTORY_REQUEST";
export const UPDATE_FACTORY_SUCCESS = "UPDATE_FACTORY_SUCCESS";
export const UPDATE_FACTORY_FAILURE = "UPDATE_FACTORY_FAILURE";

export const GET_FACTORY_DOCUMENT_REQUEST = "GET_FACTORY_DOCUMENT_REQUEST";
export const GET_FACTORY_DOCUMENT_SUCCESS = "GET_FACTORY_DOCUMENT_SUCCESS";
export const GET_FACTORY_DOCUMENT_FAILURE = "GET_FACTORY_DOCUMENT_FAILURE";

export const GET_ALL_REVENUES_REQUEST = "GET_ALL_REVENUES_REQUEST";
export const GET_ALL_REVENUES_SUCCESS = "GET_ALL_REVENUES_SUCCESS";
export const GET_ALL_REVENUES_FAILURE = "GET_ALL_REVENUES_FAILURE";

export const GET_ALL_FACTORY_TYPE_REQUEST = "GET_ALL_FACTORY_TYPE_REQUEST";
export const GET_ALL_FACTORY_TYPE_SUCCESS = "GET_ALL_FACTORY_TYPE_SUCCESS";
export const GET_ALL_FACTORY_TYPE_FAILURE = "GET_ALL_FACTORY_TYPE_FAILURE";

export const CREATE_EDIT_API_STATUS_SELLER = "CREATE_EDIT_API_STATUS_SELLER";

export const SELLER_LOADER = "SELLER_LOADER";
export const CREATE_SELLER_DISABLE = "CREATE_SELLER_DISABLE";
